import { useCheckPermissionOR, useUserInfo } from 'hooks';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import {
  MEMBER_TYPE_MANUFACTURER,
  MEMBER_TYPE_SPARK,
  MEMBER_TYPE_RESTRICTED,
} from 'static/Constants';

const useCheckIXOneCapturePermission = () => {
  const checkPermissionOr = useCheckPermissionOR();
  const { userInfo } = useUserInfo();

  const hasIXOneCaptureMemberTypeBypass = [
    MEMBER_TYPE_MANUFACTURER,
    MEMBER_TYPE_SPARK,
    MEMBER_TYPE_RESTRICTED,
  ]
    .map((type) => type?.toLowerCase())
    .includes(userInfo?.member?.memberType?.toLowerCase());

  const hasPermissionIXOneCapture =
    checkPermissionOr([
      [ABILITY_ACTION.SEND, ABILITY_SUBJECT.PRODUCTS_TO_IXONE],
    ]) || hasIXOneCaptureMemberTypeBypass;

  return {
    hasPermissionIXOneCapture,
  };
};

export default useCheckIXOneCapturePermission;
